import React, { FunctionComponent, useState } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'

import {
  updateRefiProducts,
  setRefiAppCreditStepState,
  optinRefiMembership,
} from '../refiActions'
import {
  selectCurrentRefi,
  selectCurrentRefiApplication,
  selectGapProduct,
} from '../../../reducers/refis'
import { Callback } from '../../../utils/types'
import { Refi, RefiApp } from '../types'
import { Product } from '../../refiTransactions/types'
import ToggleBoxField from '../../../components/inputs/toggleBoxField'
import LoaderButton from '../../../components/loaderButton'

interface Props {
  gapProduct: Product
  updateRefiProducts: Callback<Promise<any>>
  refiApp: RefiApp
  refi: Refi
  setRefiAppCreditStepState: Callback
  optinRefiMembership: Callback<Promise<any>>
}

export const MembershipAndGapSelection: FunctionComponent<Props> = ({
  gapProduct,
  updateRefiProducts,
  refiApp,
  refi,
  setRefiAppCreditStepState,
  optinRefiMembership,
}) => {
  const [isMembershipAccepted, setIsMembershipAccepted] = useState(true)
  const [isGapAccepted, setIsGapAccepted] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const gapOption = gapProduct?.options[0]

  const handleClickNext = () => {
    setIsLoading(true)

    if (isMembershipAccepted && !refi.membership_id)
      optinRefiMembership(refiApp.refiId)

    // check if no gap or if gap selection didn't change
    if (!gapProduct || !!gapProduct.selected_option_id === isGapAccepted) {
      setRefiAppCreditStepState('VscProducts')
      setIsLoading(false)
      return
    }

    const updateRefiProductsData = {
      options: isGapAccepted ? [[gapProduct?.id, gapOption?.id]] : [],
      surcharges: [],
      id: refiApp.refiId,
      user_id: refiApp.userId,
      skip_update_application: true,
    }
    updateRefiProducts(updateRefiProductsData)
      .then(() => {
        setRefiAppCreditStepState('VscProducts')
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }

  return (
    <div>
      <div className="coverage__sub-header coverage__sub-header--margin-bottom">
        Available protection products
      </div>
      <div className="flex-align-vert-center">
        <div className="coverage__sub-header">
          Free 60-Day membership in Drive America
        </div>
      </div>

      {refi.membership_id ? (
        <div className="coverage__header coverage__small-margin-top">
          Membership already accepted (id "{refi.membership_id}")
        </div>
      ) : (
        <ToggleBoxField
          name="drive-america-free-membership"
          options={[
            {
              label: 'Yes, accept',
              value: 'membership-yes',
              checked: isMembershipAccepted,
            },
            {
              label: 'No thanks',
              value: 'membership-no',
              checked: !isMembershipAccepted,
            },
          ]}
          onChange={(value) =>
            setIsMembershipAccepted(value === 'membership-yes')
          }
        />
      )}
      {gapOption && (
        <div>
          <div className="flex-align-vert-center">
            <div className="coverage__sub-header">
              GAP Insurance +
              {numeral(gapOption.monthly_payment).format('$0,0.00')} / month (+
              {numeral(gapOption.total_cost).format('$0,0.00')} total)
            </div>
          </div>
          <ToggleBoxField
            name="drive-america-gap-insurance"
            options={[
              {
                label: 'Yes, accept',
                value: 'gap-yes',
                checked: isGapAccepted,
              },
              {
                label: 'No thanks',
                value: 'gap-no',
                checked: !isGapAccepted,
              },
            ]}
            onChange={(value) => setIsGapAccepted(value === 'gap-yes')}
          />
        </div>
      )}
      <LoaderButton
        className="button button-drive-america"
        onClick={handleClickNext}
        isLoading={isLoading}
        data-testid="gap-membership-next"
      >
        Next
      </LoaderButton>
    </div>
  )
}

export const mapStateToProps = (state) => ({
  gapProduct: selectGapProduct(state),
  refiApp: selectCurrentRefiApplication(state),
  refi: selectCurrentRefi(state),
})

export default connect(mapStateToProps, {
  updateRefiProducts,
  setRefiAppCreditStepState,
  optinRefiMembership,
})(MembershipAndGapSelection)
